const forgotPasswordFormData = {
  password: {
    value: "",
    type: "password",
    label: "Password",
    errorMsg: "Please ensure your password meets the requirements above",
    belowPlaceholder:
      "Must include an upper and lowercase letter, number and be at least 6 characters.",
    validation: {
      require: true,
      passsword: true,
      maxLength: 20
    },
    maxLength: "20",
    valid: true
  },
  confirmPassword: {
    value: "",
    type: "password",
    label: "Confirm new password",
    errorMsg: "Please make sure your passwords match",
    placeholder: "Re-enter your new password",
    validation: {
      require: false,
      matchPassword: true,
      maxLength: 20
    },
    maxLength: "20",
    valid: true
  }
};

export default forgotPasswordFormData;
